"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.robotScript = void 0;
const tslib_1 = require("tslib");
const Blockly = tslib_1.__importStar(require("blockly"));
const Lua = tslib_1.__importStar(require("blockly/lua_compressed.js"));
const dict_1 = tslib_1.__importDefault(require("../config/dict"));
const model_1 = require("@/model");
const utils_1 = require("@/utils");
const PRECEDENCE = 0;
class RobotScript extends Blockly.Generator {
    constructor() {
        super(...arguments);
        this.scrub_ = function (block, code, thisOnly) {
            const nextBlock = block.nextConnection && block.nextConnection.targetBlock();
            if (nextBlock && !thisOnly) {
                return code + ',\n' + exports.robotScript.blockToCode(nextBlock);
            }
            return code;
        };
        this.controls_ifelse = this.controls_if;
    }
    vars_def(block) {
        return json();
    }
    vars_get(block) {
        const textValue = block.getFieldValue('VAR');
        const order = RobotScript.ORDER_ATOMIC;
        const code = utils_1.Utils.pinyin(textValue);
        return [code, order];
    }
    vars_set(block) {
        const textVar = block.getFieldValue('VAR');
        const textValue = RobotScript.valueToCode(block, 'VALUE', RobotScript.ORDER_ASSIGNMENT) || '0';
        let { cmds, params } = model_1.Project.current().curProgram.program.translationCalcStr(textValue);
        console.log('result:', params);
        return json([...cmds, ['Set', [utils_1.Utils.pinyin(textVar), ...params]]]);
    }
    tag_mark(block) {
        const textValue = block.getFieldValue('TAG');
        return json(['Label', [utils_1.Utils.pinyin(textValue)]]);
    }
    tag_jump(block) {
        const textValue = block.getFieldValue('TAG');
        return json(['Goto', [utils_1.Utils.pinyin(textValue)]]);
    }
    run_program(block) {
        const textValue = block.getFieldValue('PROGRAM');
        return json(['Call', [utils_1.Utils.pinyin(textValue)]]);
    }
    run_sync(block) {
        const textValue = block.getFieldValue('PROGRAM');
        return json(['Run', [utils_1.Utils.pinyin(textValue)]]);
    }
    run_invoke(block) {
        const textValue = block.getFieldValue('PROGRAM');
        return json(['Call', [utils_1.Utils.pinyin(textValue)]]);
    }
    run_kill(block) {
        const textValue = block.getFieldValue('PROGRAM');
        return json(['Kill', [utils_1.Utils.pinyin(textValue)]]);
    }
    controls_if(block) {
        let pg = model_1.Project.current().curProgram.program;
        let i = 0;
        let dos = [];
        let vars = [];
        while (block.getInput(`IF${i}`)) {
            const IF = RobotScript.valueToCode(block, `IF${i}`, RobotScript.ORDER_NONE);
            const DO = RobotScript.statementToCode(block, i == 0 ? 'DO' : `DO${i}`);
            if (IF !== "") {
                let { cmds, params } = pg.translationCalcStr(IF);
                console.log('cmds', cmds);
                console.log('params', params);
                if (cmds.length > 0)
                    vars.push(cmds);
                dos.push([[i == 0 ? 'If' : 'ElseIf', params], DO]);
            }
            else {
                dos.push([[i == 0 ? 'If' : 'ElseIf', IF], DO]);
            }
            i++;
        }
        const ELSE = RobotScript.statementToCode(block, 'ELSE');
        return json([vars, ...dos, ['Else'], ELSE, ['EndIf']]);
    }
    controls_repeat_ext(block) {
        let repeats;
        if (block.getField('TIMES')) {
            repeats = String(Number(block.getFieldValue('TIMES')));
        }
        else {
            repeats = RobotScript.valueToCode(block, 'TIMES', RobotScript.ORDER_ASSIGNMENT) || '0';
        }
        console.log(repeats);
        let branch = RobotScript.statementToCode(block, 'DO');
        branch = exports.robotScript.addLoopTrap(branch, block);
        let code = '';
        const loopVar = '';
        let endVar = repeats;
        if (!Blockly.utils.string.isNumber(repeats) && !repeats.match(/^\w+$/)) {
            code += 'var ' + endVar + ' = ' + repeats + ';\n';
        }
        code += `For ${branch} EndFor`;
        let { cmds, params } = model_1.Project.current().curProgram.program.translationCalcStr(repeats);
        return json([...cmds, ['For', params], branch, ['EndFor']]);
    }
    controls_while(block) {
        let argument0 = RobotScript.valueToCode(block, 'IF0', RobotScript.ORDER_NONE) || 'false';
        let branch = RobotScript.statementToCode(block, 'DO');
        branch = exports.robotScript.addLoopTrap(branch, block);
        branch = addContinueLabel(branch);
        let { cmds, params } = model_1.Project.current().curProgram.program.translationCalcStr(argument0);
        return json([cmds, ['While', params], branch, cmds, ['EndWhile']]);
    }
    logic_null(block) {
        return ['null', PRECEDENCE];
    }
    text(block) {
        const textValue = block.getFieldValue('TEXT');
        const code = `${textValue}`;
        return [code, PRECEDENCE];
    }
    math_number(block) {
        const code = Number(block.getFieldValue('NUM'));
        const order = code >= 0 ? RobotScript.ORDER_ATOMIC : RobotScript.ORDER_UNARY_NEGATION;
        return [code, order];
    }
    math_gate(block) {
        const order = RobotScript.ORDER_ATOMIC;
        const OPERATORS = { 'AND': '&', 'OR': '|', 'NEG': '~', 'XOR': '^' };
        const operator = OPERATORS[block.getFieldValue('OP')];
        const argument0 = RobotScript.valueToCode(block, 'A', RobotScript.ORDER_RELATIONAL) || '0';
        const argument1 = RobotScript.valueToCode(block, 'B', RobotScript.ORDER_RELATIONAL) || '0';
        const code = `(${argument0} ${operator} ${argument1})`;
        return [code, order];
    }
    pose_set_axis(block) {
        const poseId = block.getFieldValue('POSE');
        const axisName = block.getFieldValue('AXIS');
        const value = RobotScript.valueToCode(block, 'VALUE', RobotScript.ORDER_ASSIGNMENT) || '0';
        let { cmds, params } = model_1.Project.current().curProgram.program.translationCalcStr(value);
        let point = model_1.Project.current().curProgram.robot.paths.find(path => path.id === poseId);
        if (!point) {
            return json(["NONE", [poseId, axisName, ...params]]);
        }
        if (['route', 'point'].includes(point.type)) {
            return json([cmds, ["SetAxis", [poseId, axisName, ...params]]]);
        }
        else if (["jointPoint", "joints"].includes(point.type)) {
            return json([cmds, ["SetAxisJ", [poseId, axisName, ...params]]]);
        }
    }
    pose_offset_axis(block) {
        const poseId = block.getFieldValue('POSE');
        const axisName = block.getFieldValue('AXIS');
        const value = RobotScript.valueToCode(block, 'VALUE', RobotScript.ORDER_ASSIGNMENT) || '0';
        let { cmds, params } = model_1.Project.current().curProgram.program.translationCalcStr(value);
        let point = model_1.Project.current().curProgram.robot.paths.find(path => path.id === poseId);
        if (!point) {
            return json(["NONE", [poseId, axisName, ...params]]);
        }
        if (['route', 'point'].includes(point.type)) {
            return json([cmds, ["OffAxis", [poseId, axisName, ...params]]]);
        }
        else if (["jointPoint", "joints"].includes(point.type)) {
            return json([cmds, ["OffAxisJ", [poseId, axisName, ...params]]]);
        }
    }
    pose_get_axis(block) {
        const pose = block.getFieldValue('POSE');
        const axis = block.getFieldValue('AXIS');
        const order = RobotScript.ORDER_ATOMIC;
        const poseStr = `${utils_1.Utils.pinyin(pose)}_${axis}`;
        return [poseStr, order];
    }
    pose_get(block) {
        const poseId = block.getFieldValue('POSE');
        return json(["GetPose", [poseId]]);
    }
    pose_coordinate_convert(block) {
        const fromId = block.getFieldValue("FROM");
        const baseId = block.getFieldValue("BASE");
        const toId = block.getFieldValue("TO");
        return json(["ConvertPose", [fromId, baseId, toId]]);
    }
    logic_negate(block) {
        const order = RobotScript.ORDER_LOGICAL_NOT;
        const argument0 = RobotScript.valueToCode(block, 'BOOL', RobotScript.ORDER_RELATIONAL) || 'true';
        const code = '!' + argument0.trim();
        return [code, order];
    }
    logic_boolean(block) {
        const order = RobotScript.ORDER_ATOMIC;
        const code = (block.getFieldValue('BOOL') === 'TRUE') ? 'true' : 'false';
        return [code, order];
    }
    logic_compare(block) {
        const order = RobotScript.ORDER_RELATIONAL2;
        const operator = model_1.OPERATORS[block.getFieldValue('OP')];
        const argument0 = RobotScript.valueToCode(block, 'A', RobotScript.ORDER_RELATIONAL) || '0';
        const argument1 = RobotScript.valueToCode(block, 'B', RobotScript.ORDER_RELATIONAL) || '0';
        const code = `(${argument0}  ${operator}  ${argument1})`;
        return [code, order];
    }
    logic_operation(block) {
        const order = RobotScript.ORDER_RELATIONAL2;
        const operator = model_1.OPERATORS[block.getFieldValue('OP')];
        const argument0 = RobotScript.valueToCode(block, 'A', RobotScript.ORDER_RELATIONAL) || '0';
        const argument1 = RobotScript.valueToCode(block, 'B', RobotScript.ORDER_RELATIONAL) || '0';
        const code = `(${argument0}  ${operator}  ${argument1})`;
        return [code, order];
    }
    math_arithmetic(block) {
        const OPERATORS = {
            'ADD': [' + ', RobotScript.ORDER_UNARY_PLUS],
            'MINUS': [' - ', RobotScript.ORDER_UNARY_NEGATION],
            'MULTIPLY': [' * ', RobotScript.ORDER_MULTIPLICATION],
            'DIVIDE': [' / ', RobotScript.ORDER_DIVISION],
            'MOD': [' % ', RobotScript.ORDER_DIVISION],
            'POWER': [' ^ ', RobotScript.ORDER_BITWISE_XOR],
        };
        const tuple = OPERATORS[block.getFieldValue('OP')];
        const operator = tuple[0];
        const order = tuple[1];
        const argument0 = RobotScript.valueToCode(block, 'A', order) || '0';
        const argument1 = RobotScript.valueToCode(block, 'B', order) || '0';
        const code = `(${argument0} ${operator} ${argument1})`;
        return [code, order];
    }
    math_self(block) {
        return json();
    }
    math_single(block) {
        const operator = block.getFieldValue('OP');
        let arg;
        if (operator === 'NEG') {
            arg = RobotScript.valueToCode(block, 'NUM', RobotScript.ORDER_UNARY) || '0';
            return ['-' + arg, RobotScript.ORDER_UNARY];
        }
        if (operator === 'POW10') {
            arg = RobotScript.valueToCode(block, 'NUM', RobotScript.ORDER_EXPONENTIATION) || '0';
            return ['10 ^ ' + arg, RobotScript.ORDER_EXPONENTIATION];
        }
        if (operator === 'ROUND') {
            arg = RobotScript.valueToCode(block, 'NUM', RobotScript.ORDER_ADDITION) || '0';
        }
        else {
            arg = RobotScript.valueToCode(block, 'NUM', RobotScript.ORDER_NONE) || '0';
        }
        let code;
        switch (operator) {
            case 'ABS':
                code = 'abs(' + arg + ')';
                break;
            case 'ROOT':
                code = 'sqrt(' + arg + ')';
                break;
            case 'FLOOR':
                code = 'floor(' + arg + ')';
                break;
            case 'RANDOM':
                code = 'random(' + arg + ')';
                break;
            case 'LN':
                code = 'log(' + arg + ')';
                break;
            case 'LOG10':
                code = 'log(' + arg + ', 10)';
                break;
            case 'EXP':
                code = 'exp(' + arg + ')';
                break;
            case 'ROUND':
                code = 'floor(' + arg + ' + .5)';
                break;
            case 'ROUNDUP':
                code = 'ceil(' + arg + ')';
                break;
            case 'ROUNDDOWN':
                code = 'floor(' + arg + ')';
                break;
            case 'SIN':
                code = 'sin(rad(' + arg + '))';
                break;
            case 'COS':
                code = 'cos(rad(' + arg + '))';
                break;
            case 'TAN':
                code = 'tan(rad(' + arg + '))';
                break;
            case 'ASIN':
                code = 'deg(asin(' + arg + '))';
                break;
            case 'ACOS':
                code = 'deg(acos(' + arg + '))';
                break;
            case 'ATAN':
                code = 'deg(atan(' + arg + '))';
                break;
            default:
                throw Error('Unknown math operator: ' + operator);
        }
        return [code, RobotScript.ORDER_ATOMIC];
    }
    move_path(block) {
        const path = block.getFieldValue('PATH') || block.getFieldValue('POINT');
        const speed = block.getFieldValue('SPEED');
        const tool = block.getFieldValue('TOOL');
        const pl = block.getFieldValue('PL');
        return json(['MovePath', [path, speed, pl, tool]]);
    }
    move_line(block) {
        const frame = block.getFieldValue('FRAME');
        const axis = block.getFieldValue('AXIS');
        const distance = block.getFieldValue('DISTANCE');
        const speed = block.getFieldValue('SPEED');
        const tool = block.getFieldValue('TOOL');
        const pl = block.getFieldValue('PL');
        return json(['MoveRelLin', [frame, axis, distance, speed, pl, tool]]);
    }
    move_skeleton(block) {
        const joint = block.getFieldValue('JOINT');
        const angle = block.getFieldValue('ANGLE');
        const speed = block.getFieldValue('SPEED');
        const pl = block.getFieldValue('PL');
        return json(['MoveRelJog', [joint, angle, speed, pl]]);
    }
    move_joints(block) {
        const speed = block.getFieldValue('SPEED');
        const joints = block.getFieldValue('JOINTS');
        const pl = block.getFieldValue('PL');
        return json(['MoveJoints', [joints, speed, pl]]);
    }
    move_point(block) {
        return this.move_path(block);
    }
    move_to(block) {
        const type = block.getFieldValue('MOVE_TYPE');
        return exports.robotScript[type](block);
    }
    move_material(block) {
        const speed = block.getFieldValue('SPEED');
        const step = block.getFieldValue('STEP');
        const ioInId = block.getFieldValue('IO_IN');
        const ioOtId = block.getFieldValue('IO_OT');
        const ioCtId = block.getFieldValue('IO_CT');
        const tool = block.getFieldValue('TOOL');
        const SUCCESS = RobotScript.statementToCode(block, 'SUCCESS') || '[]';
        const FAIL = RobotScript.statementToCode(block, 'FAIL') || '[]';
        return json(['MoveMaterial', [speed, step, ioInId, ioOtId, ioCtId, tool, JSON.parse(`[${SUCCESS}]`), JSON.parse(`[${FAIL}]`)]]);
    }
    state_get(block) {
        const type = block.getFieldValue('STATE_TYPE');
        if (type === "POSE") {
            return exports.robotScript.io_get_pt(block);
        }
        else if (type === "JOINT") {
            return exports.robotScript.io_get_axis(block);
        }
        return json();
    }
    timer_def(block) {
        const sign_type = block.getFieldValue('SIGN_TYPE');
        const var_name = block.getFieldValue('VAR');
        return json();
    }
    timer_state(block) {
        const sign_type = block.getFieldValue('SIGN_TYPE');
        const var_name = block.getFieldValue('VAR');
        return json([sign_type, [utils_1.Utils.pinyin(var_name)]]);
    }
    timer_wait(block) {
        const times = block.getFieldValue('TIMES');
        return json(['WaitTime', [times]]);
    }
    io_get_pt(block) {
        const var_name = block.getFieldValue('VAR');
        return json(['GetPose', [var_name]]);
    }
    io_get_axis(block) {
        const var_name = block.getFieldValue('VAR');
        return json(['GetJoint', [var_name]]);
    }
    io_get_sign(block) {
        const ioId = block.getFieldValue('IO_ID');
        const order = RobotScript.ORDER_ATOMIC;
        const io = model_1.Project.current().curProgram.robot.code.ioList.find(io => io.id == ioId);
        return [(io === null || io === void 0 ? void 0 : io.id) || ioId, order];
    }
    io_save_sign(block) {
        const ioId = block.getFieldValue('IO_ID');
        const io = model_1.Project.current().curProgram.robot.code.ioList.find(io => io.id == ioId);
        if (!io)
            return json();
        const var_name = block.getFieldValue('VAR');
        switch (io.type) {
            case model_1.IO_TYPE.DI:
            case model_1.IO_TYPE.AI:
            case model_1.IO_TYPE.GI:
                return json([`Read${io.type}`, [io.name, var_name]]);
        }
    }
    io_wait_sign(block) {
        const ioId = block.getFieldValue('IO_ID');
        const value = block.getFieldValue('VALUE');
        const io = model_1.Project.current().curProgram.robot.code.ioList.find(io => io.id == ioId);
        if (!io)
            return json();
        switch (io.type) {
            case model_1.IO_TYPE.DI:
            case model_1.IO_TYPE.AI:
            case model_1.IO_TYPE.GI:
                return json([`Wait${io.type}`, [io.id, Number(value)]]);
        }
    }
    io_send_digital(block) {
        const ioId = block.getFieldValue('IO_ID');
        const value = block.getFieldValue('VALUE');
        const is_pulse = block.getFieldValue('IS_PULSE') === 'TRUE';
        const io = model_1.Project.current().curProgram.robot.code.ioList.find(io => io.id == ioId);
        if (!io)
            return json();
        if (is_pulse) {
            const time = block.getFieldValue('TIME');
            return json(['SendPulse', [io.id, Number(value), time, (Number(value) + 1) % 2]]);
        }
        return json(['SendDO', [io.id, value,]]);
    }
    io_send_analog(block) {
        const ioId = block.getFieldValue('IO_ID');
        const value = block.getFieldValue('VALUE');
        const time = block.getFieldValue('TIME');
        const ie = (block.getFieldValue('IS_IE') === 'TRUE') ? 'Y' : 'N';
        const io = model_1.Project.current().curProgram.robot.code.ioList.find(io => io.id == ioId);
        if (!io)
            return json();
        return json(['SendAO', [io.id, Number(value), time, ie]]);
    }
    io_send_dec(block) {
        const ioId = block.getFieldValue('IO_ID');
        const value = block.getFieldValue('VALUE');
        const io = model_1.Project.current().curProgram.robot.code.ioList.find(io => io.id == ioId);
        if (!io)
            return json();
        return json(['SendGO', [io.id, Number(value)]]);
    }
    io_send_sign(block) {
        const ioId = block.getFieldValue('IO_ID');
        let io = model_1.Project.current().curProgram.robot.code.ioList.find(io => io.id == ioId);
        if (!io)
            return json();
        switch (io.type) {
            case model_1.IO_TYPE.DO:
                return exports.robotScript.io_send_digital(block);
            case model_1.IO_TYPE.AO:
                return exports.robotScript.io_send_analog(block);
            case model_1.IO_TYPE.GO:
                return exports.robotScript.io_send_dec(block);
        }
    }
    sys_io_send_sign(block) {
        const ioId = block.getFieldValue('IO_ID');
        const value = block.getFieldValue('VALUE');
        return json(['SendSO', [ioId, value,]]);
    }
    sys_io_wait_sign(block) {
        const ioId = block.getFieldValue('IO_ID');
        const value = block.getFieldValue('VALUE');
        return json(["WaitSI", [ioId, Number(value)]]);
    }
    set_coordinate(block) {
        const frame = block.getFieldValue('COORDINATE');
        let ucs = model_1.Project.current().getUcs().find((u => u.id == frame));
        let type = ucs && ucs.reference.frame === 'tool' ? 'tool' : 'base';
        if ((ucs === null || ucs === void 0 ? void 0 : ucs.reference.frame) === 'rp')
            type = 'user';
        return json(['SetCoord', [type, frame]]);
    }
    set_dynamic(block) {
        const TYPES = { SPEED: 0, ACC: 1, DEC: 2, MOMENTAL: 4 };
        const type = TYPES[block.getFieldValue('TYPE')];
        const value = block.getFieldValue('VALUE');
        if (type == 0) {
            return json(['SetSpeed', [value]]);
        }
        return json(['SetDyn', [type, value]]);
    }
    set_error(block) {
        const value = block.getFieldValue('VALUE');
        return json(['SetErr', [value.replace(/\\n/g, '')]]);
    }
    set_stop(block) {
        const value = block.getFieldValue('VALUE');
        return json(['SetStop', [value.replace(/\\n/g, '')]]);
    }
    intCode(code) {
        Object.keys(dict_1.default).some(key => {
            let v = dict_1.default[key];
            if (code === key) {
                code = parseFloat(code.replace(key, v));
                return true;
            }
            return false;
        });
        return code;
    }
    static valueToCode(block, name, outerOrder) {
        let code = exports.robotScript.valueToCode(block, name, outerOrder);
        return code.trim ? code.trim() : code;
    }
    static statementToCode(block, name) {
        let code = exports.robotScript.statementToCode(block, name);
        return code.trim ? code.trim() : code;
    }
}
RobotScript.ORDER_ATOMIC = 0;
RobotScript.ORDER_NEW = 1.1;
RobotScript.ORDER_MEMBER = 1.2;
RobotScript.ORDER_FUNCTION_CALL = 2;
RobotScript.ORDER_INCREMENT = 3;
RobotScript.ORDER_DECREMENT = 3;
RobotScript.ORDER_BITWISE_NOT = 4.1;
RobotScript.ORDER_UNARY_PLUS = 4.2;
RobotScript.ORDER_UNARY_NEGATION = 4.3;
RobotScript.ORDER_LOGICAL_NOT = 4.4;
RobotScript.ORDER_TYPEOF = 4.5;
RobotScript.ORDER_VOID = 4.6;
RobotScript.ORDER_DELETE = 4.7;
RobotScript.ORDER_AWAIT = 4.8;
RobotScript.ORDER_EXPONENTIATION = 5.0;
RobotScript.ORDER_MULTIPLICATION = 5.1;
RobotScript.ORDER_DIVISION = 5.2;
RobotScript.ORDER_MODULUS = 5.3;
RobotScript.ORDER_SUBTRACTION = 6.1;
RobotScript.ORDER_ADDITION = 6.2;
RobotScript.ORDER_BITWISE_SHIFT = 7;
RobotScript.ORDER_RELATIONAL = 8;
RobotScript.ORDER_IN = 8;
RobotScript.ORDER_INSTANCEOF = 8;
RobotScript.ORDER_EQUALITY = 9;
RobotScript.ORDER_BITWISE_AND = 10;
RobotScript.ORDER_BITWISE_XOR = 11;
RobotScript.ORDER_UNARY = 11.1;
RobotScript.ORDER_BITWISE_OR = 12;
RobotScript.ORDER_LOGICAL_AND = 13;
RobotScript.ORDER_LOGICAL_OR = 14;
RobotScript.ORDER_CONDITIONAL = 15;
RobotScript.ORDER_ASSIGNMENT = 16;
RobotScript.ORDER_YIELD = 17;
RobotScript.ORDER_COMMA = 18;
RobotScript.ORDER_HIGH2 = 1;
RobotScript.ORDER_BITXOR2 = 2;
RobotScript.ORDER_UNARY2 = 3;
RobotScript.ORDER_MULTIPLICATIVE2 = 4;
RobotScript.ORDER_ADDITIVE2 = 5;
RobotScript.ORDER_CONCATENATION2 = 6;
RobotScript.ORDER_RELATIONAL2 = 7;
RobotScript.ORDER_AND = 19;
RobotScript.ORDER_OR = 20;
RobotScript.ORDER_NONE = 99;
const CONTINUE_STATEMENT = 'goto continue\n';
const addContinueLabel = function (branch) {
    if (branch.indexOf(CONTINUE_STATEMENT) !== -1) {
        return branch + Lua.INDENT + '::continue::\n';
    }
    else {
        return branch;
    }
};
const json = function (array) {
    if (typeof array === 'string') {
        if (array.indexOf('[') == 0) {
            try {
                return JSON.parse(`[${array}]`).map(a => JSON.stringify(a)).join(',\n');
            }
            catch (e) {
                console.log(e);
                return array;
            }
        }
        else {
            return array;
        }
    }
    if (array && array.length) {
        if (typeof array[0] === 'string') {
            let arrClone = JSON.parse(JSON.stringify(array));
            return JSON.stringify([exports.robotScript.intCode(arrClone.shift()), ...arrClone]);
        }
        else {
            return array.filter((a) => a.length).map((a) => json(a)).join(',\n');
        }
    }
    return "[]";
};
exports.robotScript = new RobotScript('RobotScript');
